var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowFall16 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05469 12.9258C5.05469 13.4781 5.5024 13.9258 6.05469 13.9258H12.0547C12.607 13.9258 13.0547 13.4781 13.0547 12.9258V6.92578C13.0547 6.3735 12.607 5.92578 12.0547 5.92578C11.5024 5.92578 11.0547 6.3735 11.0547 6.92578V10.5116L4.76179 4.21867C4.37127 3.82815 3.7381 3.82815 3.34758 4.21867C2.95706 4.6092 2.95706 5.24236 3.34758 5.63289L9.64047 11.9258H6.05469C5.5024 11.9258 5.05469 12.3735 5.05469 12.9258Z",
    fill: "#FF6666"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowFall16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_arrow_fall_16.4db7a913b60ec7a75814c511f0d1e2d6.svg";